function Footer() {
  return (
    <footer className='footer bg-[#171C30] w-full py-12 justify-center flex items-center flex-col'>
      <h6 className='w-14 md:w-[6.5rem]'>
        <img
          className='w-full h-full'
          src={`${process.env.PUBLIC_URL}/assets/images/common/img_logo_white.svg`}
          alt=''
        />
      </h6>
      <p className='mt-3 text-xs font-normal leading-4 text-center text-white md:text-sm md:leading-6 md:mt-5'>
        상호 : (주)노아 577-86-00784{' '}
        <span className='block text-xs font-normal md:inline-block md:text-sm'>
          주소 : 대전광역시 서구 대덕대로 241번길 35 용빌딩 3층
        </span>
      </p>
      <p className='text-xs font-normal leading-4 text-white md:text-sm md:leading-6'>
        고객센터 : 1522-3362
      </p>
      <p className='text-xs font-normal leading-4 text-white md:text-sm md:leading-6'>
        제조 : 에스에스바이오팜
      </p>
      <p className='mt-1 text-xs leading-4 text-white opacity-50 md:text-sm md:leading-6'>
        Copyright 2023. NOAH inc. all rights reserved.
      </p>
    </footer>
  );
}

export default Footer;
